import React, { useEffect, useRef, useState, useContext } from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'
import moment from 'moment'
import {
  required,
  composeValidators,
  postCode,
} from '../../utils/validation'
import TextInput from '../../components/TextInput/index'
import FlexBox from '../../components/Flexbox'
import DatePicker from '../../components/DatePicker/DatePicker'
import Select from '../../components/Select/index'
import { disabilityOptions } from './constants'
import Checkbox from '../../components/Checkbox'
import { voivodeships } from '../../components/Units/utils'
import { AppContext } from '../App'

const fieldWidth = 500
const fieldWidthSmall = 250

const genderOptions = [
  { value: 'Male', label: 'Męska' },
  { value: 'Female', label: 'Żeńska' },
]

const PatientForm = ({ editable }) => {
  const {
    hiddenSchoolSection,
    onClickHideSchool,
  } = useContext(AppContext)
  const [date] = useState()
  const [gender] = useState('')

  // manual set up of datepicker and select
  const dateRef = useRef(null)
  const genderRef = useRef(null)
  const currentDay = new Date()
  const minDate = new Date(
    currentDay.setFullYear(currentDay.getFullYear() - 25)
  )
  useEffect(() => {
    if (dateRef?.current && date) {
      dateRef.current.handleSelect(moment(date))
    }
    if (genderRef?.current && gender) {
      genderRef.current.onChange(
        genderOptions.find((el) => el.value === gender)
      )
    }
  }, [dateRef?.current, date, genderRef?.current, gender])

  return (
    <FormWrapper>
      <FlexBox direction="column" align="center">
        <H2>Dane osoby diagnozowanej</H2>
        <FieldWrap>
          <Field
            name="dateOfBirth"
            component={DatePicker}
            width={fieldWidthSmall}
            label="Data urodzenia"
            maxDate={moment()}
            minDate={moment(minDate)}
            readOnly={!editable}
            initialValue={date}
            value={date}
            reference={dateRef}
            validate={required}
            autocomplete="bday"
          />
          <Field
            name="gender"
            reference={genderRef}
            component={Select}
            width={fieldWidthSmall}
            label="Płeć"
            aria-label={"Płeć"}
            options={genderOptions}
            disabled={!editable}
            validate={required}
            autocomplete="sex"
          />
        </FieldWrap>
        <Field
          component={Select}
          options={disabilityOptions}
          width={fieldWidth}
          marginTop
          label="Grupa"
          aria-label={"Grupa"}
          name="disability"
          disabled={!editable}
          validate={required}
        />

        <H2>Jednostka systemu oświaty</H2>
        <StyledCheckbox
          label="Nie dotyczy"
          input={{
            value: hiddenSchoolSection,
            onChange: () => onClickHideSchool(),
          }}
        />

        <div aria-live="polite">
          {!hiddenSchoolSection && (
            <>
              <Field
                component={TextInput}
                width={fieldWidth}
                label="Nazwa przedszkola lub szkoły"
                type="text"
                name="school.name"
                validate={required}
                autocomplete="organization"
              />
              <FieldWrap>
                <Field
                  component={TextInput}
                  width={fieldWidthSmall}
                  label="Ulica i numer"
                  type="text"
                  name="school.address.street"
                  validate={required}
                  autocomplete="address-level3"
                />
                <Field
                  component={TextInput}
                  width={fieldWidthSmall}
                  label="Miasto"
                  type="text"
                  name="school.address.city"
                  validate={required}
                  autocomplete="address-level2"
                />
              </FieldWrap>
              <FieldWrap>
                <Field
                  component={TextInput}
                  width={fieldWidthSmall}
                  label="Kod Pocztowy"
                  type="text"
                  name="school.address.postcode"
                  maxLength="6"
                  validate={composeValidators(required, postCode)}
                  autocomplete="postal-code"
                />
                <Field
                  component={Select}
                  width={fieldWidthSmall}
                  label="Województwo"
                  aria-label={"Województwo"}
                  options={voivodeships}
                  name="school.address.voivodeship"
                  validate={required}
                  autocomplete="address-level1"
                />
              </FieldWrap>
              <Field
                component={TextInput}
                width={fieldWidth}
                label="Oddział (np. klasa)"
                type="text"
                name="school.groupName"
                validate={required}
              />
            </>
          )}
        </div>
      </FlexBox>
    </FormWrapper>
  )
}
const H2 = styled.h2`
  font-weight: 400;
  margin-bottom: 50px;
`

const FormWrapper = styled.form`
  align-items: start;
  margin: 50px auto 0;
  display: grid;
  grid-gap: 50px;
  grid: 1fr /1fr 1fr;
  @media (max-width: 1100px) {
    grid: 1fr 1fr/1fr;
  }
`
const FieldWrap = styled.div`
  display: flex;
  align-items: center;
`
const StyledCheckbox = styled(Checkbox)`
  margin: 10px 0 55px;

  label {
    flex-direction: row;
    font-weight: 100;
  }
`

export default PatientForm
